import Parallax	from "./circuits/parallax.js";

class AcidPump extends Parallax {
	constructor(p) {
		super(0x10, 3);
	}
	async update() {     
      return true;
	}
	toJSON() {
		return({
			id: this.id,
			status: this.status,
			rpm: this.rpm,
			mlh: this.mlh,
			calibrationStatus: this.calibrationStatus,
			sumML: this.sumML
		});
	}
}

export default AcidPump;